export class ProcessosFiltradosFiltro {
  DataInicial?: string;
  DataFinal?: string;
  DataCriacao: string;
  EstadoDoProcessoId: number;
  UnidadeId: number;
  CidadeId: number;
  TipoDeAcaoId: number;
  NaturezaDeAcaoId: number;
  AdvogadoId: number;
  EncaminhadoPor: number;
  ParteContraria: string;
  Registros: number;
  constructor() {
    let hoje = new Date();
    
    hoje.setDate(1); // primeiro dia desse mês
    this.DataInicial = hoje.toISOString().split('T')[0];
    
    hoje.setMonth(hoje.getMonth() + 1); 
    hoje.setDate(0); // último dia desse mês (com esses dois comandos funcionou, vai saber kkkk)
    this.DataFinal = hoje.toISOString().split('T')[0];

    this.EstadoDoProcessoId = 0;
    this.UnidadeId = 0;
    this.CidadeId = 0;
    this.TipoDeAcaoId = 0;
    this.NaturezaDeAcaoId = 0;
    this.AdvogadoId = 0;
    this.EncaminhadoPor = 0;
    this.ParteContraria = "";
    this.Registros = 15;

  }
}

export class ProcessosFiltrados {
  NomeCliente: string;
  CidadeCliente: string;
  Processo: string;
  Unidade: string;
  ParteContraria: string;
  EstadoDoProcesso: string;
  NaturezaDeAcao: string;
  TipoDeAcao: string;
  NomeEncaminhador: string;
  NomeAdvogado: string;
}
